import { render } from "./user-right-intro.vue?vue&type=template&id=b2fa2a34&ts=true"
import script from "./user-right-intro.vue?vue&type=script&lang=ts"
export * from "./user-right-intro.vue?vue&type=script&lang=ts"

import "./user-right-intro.vue?vue&type=style&index=0&id=b2fa2a34&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__